export default __webpack_public_path__ + "static/media/btn-gnb-cart.db3d2796.svg";